// Qué hace «Reabrir» con cada `code` de POST /prospects/{id}/resume (contrato del silo, E2).
import { wizardErrorCode, wizardErrorMsg } from '@/domains/sales/wizard/api/wizardError';
import {
    OTHER_STORE_SALE_HINT,
    OTHER_STORE_SALE_MESSAGE,
} from '@/domains/sales/wizard/phoneHolder';
import { WIZARD_NO_PHONE_NOTE } from './prospectsFormat';

export type ReopenFailureKind = 'REFRESH_LIST' | 'CLOSED' | 'OTHER_STORE' | 'NO_PHONE' | 'RETRY';

export interface ReopenFailure {
    kind: ReopenFailureKind;
    message: string;
}

export const REOPEN_NOT_FOUND_NOTE =
    'Este prospecto ya no está en tu agenda. Actualizamos la lista.';
export const REOPEN_CLOSED_NOTE =
    'Este prospecto ya se cerró. Si el cliente quiere comprar, inicia una venta nueva.';
export const REOPEN_OTHER_STORE_NOTE = `${OTHER_STORE_SALE_MESSAGE}. ${OTHER_STORE_SALE_HINT}`;
export const REOPEN_RETRY_NOTE = 'No se pudo reabrir la venta. Intenta de nuevo.';
export const REOPEN_CHECKPOINT_NOTE =
    'La venta ya no está en la pantalla donde se guardó: retoma desde su último punto guardado.';

export function reopenFailureOf(error: unknown): ReopenFailure {
    switch (wizardErrorCode(error)) {
        case 'PROSPECT_NOT_FOUND':
            return { kind: 'REFRESH_LIST', message: REOPEN_NOT_FOUND_NOTE };
        case 'PROSPECT_CLOSED':
            return { kind: 'CLOSED', message: REOPEN_CLOSED_NOTE };
        case 'SESSION_ACTIVE_OTHER_STORE':
            return { kind: 'OTHER_STORE', message: REOPEN_OTHER_STORE_NOTE };
        case 'PROSPECT_WITHOUT_PHONE':
            return { kind: 'NO_PHONE', message: WIZARD_NO_PHONE_NOTE };
        default:
            return { kind: 'RETRY', message: wizardErrorMsg(error, REOPEN_RETRY_NOTE) };
    }
}
